import { useMutation } from "@tanstack/react-query";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../consts/api";

export const useChargeWithSunbitMutation = () => {
  return useMutation((req) => {
    return http.post(HTTP_ENDPOINTS.sunbit.checkout(), {
      sunbitPayment: {
        invoiceId: req.invoiceId,
        requestedAmount: req.requestedAmount,
        patientPhone: req.patientPhone,
        patientEmail: req.patientEmail,
      },
    });
  });
};
